/* eslint-disable no-param-reassign */
import axios from 'axios';
import store from '../store/index';

axios.defaults.baseURL = store.state.apiUrl;
axios.defaults.timeout = 0;

axios.interceptors.request.use((request) => {
  const token = store.getters['user/getAuthToken'];
  if (token) {
    request.headers.common.Authorization = `Bearer ${token}`;
  }
  return request;
});

export default axios;



// WEBPACK FOOTER //
// ./src/conf/axios.js